import FormLogisticOriginCreate from './FormLogisticOriginCreate';
import FormLogisticOriginDelete from './FormLogisticOriginDelete';
import FormLogisticOriginUpdate from './FormLogisticOriginUpdate';

export default Object.assign(
  {},
  {
    Create: FormLogisticOriginCreate,
    Update: FormLogisticOriginUpdate,
    Delete: FormLogisticOriginDelete,
  },
);
